import { Link } from "react-router-dom";
import { Home } from "lucide-react";
import { TintiMark } from "@/components/layout/TintiLogo";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center text-center">
      <TintiMark className="h-16 w-16" />
      <p className="mt-6 font-heading text-6xl font-bold text-foreground">404</p>
      <p className="mt-2 text-sm text-muted-foreground">Página não encontrada nesta região da nuvem.</p>
      <Link to="/" className="mt-6"><Button className="bg-brand text-white hover:bg-brand-hover" data-testid="notfound-home"><Home className="h-4 w-4" /> Voltar ao Dashboard</Button></Link>
    </div>
  );
}
